module.exports = __webpack_public_path__ + "static/media/about-2.02f0f274.jpg";